import { combineReducers } from 'redux';

import byThreadId from './byThreadId/reducer';

export default combineReducers({
  byThreadId
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/paging/mailThreadMessages/reducer.js
 **/